import { StyleSheet } from "@react-pdf/renderer";
import type { TemplateStyles } from "@/interfaces";

export const Classic: TemplateStyles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 40,
    fontFamily: "Times-Roman",
    fontSize: 11,
    color: "#000000",
  },
  header: {
    marginBottom: 20,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    borderBottom: "2px solid #000000",
    paddingBottom: 12,
  },
  name: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 6,
    letterSpacing: 0.3,
    fontFamily: "Times-Bold",
  },
  title: {
    fontSize: 13,
    fontWeight: "normal",
    color: "#1a1a1a",
    marginBottom: 10,
    fontStyle: "italic",
  },
  contactInfo: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 12,
    fontSize: 9,
    color: "#2a2a2a",
    gap: 4,
  },
  contactItem: {
    lineHeight: 0.8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
  contactIcon: {
    width: 8,
    height: 8,
    transform: "translateY(-2px)",
  },
  section: {
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 8,
    textTransform: "uppercase",
    textAlign: "left",
    letterSpacing: 1,
    color: "#000000",
    fontFamily: "Times-Bold",
    paddingBottom: 4,
  },
  summary: {
    fontSize: 11,
    lineHeight: 1.6,
    textAlign: "left",
    marginBottom: 12,
    color: "#2a2a2a",
    fontStyle: "italic",
  },
  skillsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 12,
    gap: 6,
  },
  skillItem: {
    marginRight: 4,
    fontSize: 10,
    color: "#2a2a2a",
  },
  skillItemBold: {
    fontWeight: "bold",
    marginRight: 8,
    fontSize: 10,
    color: "#000000",
    fontFamily: "Times-Bold",
  },
  skillSeparator: {
    color: "#666666",
  },
  itemContainer: {
    margin: 10,
    marginLeft: 0,
  },
  itemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
    alignItems: "flex-start",
  },
  itemTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#000000",
    fontFamily: "Times-Bold",
  },
  itemSubtitle: {
    fontSize: 11,
    color: "#2a2a2a",
    marginTop: 2,
    marginBottom: 4,
    fontStyle: "italic",
  },
  itemDate: {
    fontSize: 10,
    color: "#4a4a4a",
    fontStyle: "italic",
    textAlign: "right",
  },
  itemDescription: {
    fontSize: 10,
    lineHeight: 1.5,
    color: "#2a2a2a",
    marginTop: 4,
    marginLeft: 0,
    textAlign: "justify",
  },
  bulletList: {
    marginTop: 6,
    marginLeft: 16,
  },
  bulletItem: {
    fontSize: 10,
    lineHeight: 1.5,
    color: "#2a2a2a",
    marginBottom: 4,
  },
  bullet: {
    marginRight: 8,
    fontSize: 10,
    color: "#000000",
    fontFamily: "Times-Bold",
  },
  languagesList: {
    flexDirection: "column",
    marginBottom: 12,
    gap: 10,
  },
  languageItem: {
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: 6,
  },
  languageName: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#000000",
    marginRight: 4,
    fontFamily: "Times-Bold",
  },
  languageLevelContainer: {
    flexDirection: "row",
    marginLeft: 20,
    marginTop: 4,
  },
  languageLevel: {
    fontSize: 10,
    color: "#2a2a2a",
    fontStyle: "italic",
  },
}) as TemplateStyles;
